import moment from "moment";

import { commonErr } from "../components/common/errors";
import { getHCMCityCoordinates } from "../components/common/common";

const defMinMiles = 1;
const defRadius = 50 / 1.60934;

export default function CSRed(
	csFinding = {
		err: commonErr.INNIT,
		viewMode: 0,
		filter: {
			//for list
			fromCarId: "",
			pos: 0,
			ver: 0,

			//for filter
			address: "Hồ Chí Minh",
			lat: 10.77959710316263,
			lng: 106.6675657995176,
			startDate: moment().add(3, 'days').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			endDate: moment(moment().add(3, 'days').valueOf()).add(1, 'months').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			timeCS: 6,
			transmission: 0,
			sort: "pl",
			fuel: 0,
			vehicleType: [],
			vehicleMake: 0,
			vehicleModel: [],
		},
	},
	action
) {
	switch (action.type) {
		case "SET_FILTER_CS": {
			return {
				...csFinding,
				filter: action.payload,
			};
		}

		case "SEARCH_CS_LIST_PENDING": {
			return {
				...csFinding,
				err: commonErr.LOADING,
			};
		}

		case "SEARCH_CS_LIST_REJECTED": {
			return {
				...csFinding,
				err: commonErr.FAIL,
			};
		}

		case "SEARCH_CS_LIST_FULFILLED": {
			const data = action.payload.data.data;
			const err = action.payload.data.error;

			if (data) {
	
				return {
					...csFinding,
					err: commonErr.SUCCESS,
					errCode: action.payload.data.error,
					cars: data.cars,
					total: data.totalCars,
					more: data.more,
					counters: data.counters,
					filter: {
						...csFinding.filter,
					},
				};
			} else {
				return {
					...csFinding,
					err: commonErr.FAIL,
					errCode: action.payload.data.error,
					errMsgBox: action.payload.data.errorMessage,
				};
			}
		}

		case "SEARCH_CS_LIST_MORE_PENDING": {
			return {
				...csFinding,
			};
		}

		case "SEARCH_CS_LIST_MORE_FULFILLED": {
			const data = action.payload.data.data;
		
			return {
				...csFinding,
				err: commonErr.SUCCESS,
				cars: csFinding.cars.concat(data.cars),
				total: data.totalCars,
				more: data.more,
				counters: data.counters,
			};
		}

		default:
			return csFinding;
	}
}
